import React, { createContext, useEffect, useState } from "react";
import validateEmail from "../../utils/service";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../constants/routesContent.json";
import deviceValue from "../../constants/dummyData.json";
import { loginApi, createAccessToken } from "../../api/Api";
import { createCookie } from "../../utils/service";

export const LoginEmailPasswordContext = createContext({});
export const LoginEmailPasswordContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [emailId, setEmailID] = useState("");
  const [password, setPassword] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [invalidPassword, setInvalidPassword] = useState(false);
  const [remberMeEnable, setRemberMeEnable] = useState(false);
  const [accessTokenData, setAccessTokenData] = useState("");
  const [refreshTokenData, setRefreshTokenData] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);

  const handleAlertSubmit = () => {
    setShowAlert(false);
  };

  const submitLogin = async () => {
    const userData = {
      email: emailId,
      password: password,
    };
    if (!validateEmail(emailId)) {
      setInvalidEmail(true);
    } else {
      setInvalidEmail(false);
    }
    if (!password) {
      setInvalidPassword(true);
    } else {
      setInvalidPassword(false);
    }

    if (validateEmail(emailId) && password !== "") {
      try {
        const getData = await loginApi(userData);
       
        if (getData.data.status === 200) {
          const token = getData.data.data.accessToken;
          const refreshToken = getData.data.data.refreshToken;
          const roleName = getData.data.data.admin.RoleName
          setAccessTokenData(getData.data.data.accessToken);
          setRefreshTokenData(getData.data.data.refreshToken);
          localStorage.setItem("x-access-token", token);
          localStorage.setItem("x-referesh-token", refreshToken);
          localStorage.setItem("is_SuperAdmin", roleName);
      
          createCookie("accessToken", token, 30);
          createCookie("refreshToken", refreshToken, 30);
          const tokenData = refreshToken;
          const decoded = jwt_decode(tokenData);
          localStorage.setItem("remember", remberMeEnable);
          localStorage.setItem(
            "permissions",
            JSON.stringify(getData?.data?.data?.admin?.Permissions)
          );
          navigate(RouteConstants.HOMEPAGE, {
            state: getData?.data?.data?.admin?.Permissions,
          });
        }
      } catch (error) {
        setStatusCode(error?.response?.data?.status);
        if (
          error?.response?.data?.status === 400 ||
          error?.response?.data?.status === 401
        ) {
          const errorMessage = error?.response?.data?.message;
          setAlertMessage(errorMessage);
          setShowAlert(true);
        } else {
          setAlertMessage("Something went wrong...");
          setShowAlert(true);
        }
      }
    }
  };

  const submitAccessToken = async () => {
    const data = {
      refreshToken: localStorage.getItem("x-referesh-token"),
    };
    try {
      const getData = await createAccessToken(data);
      if (getData.data.status === 200) {
        const token = getData.data.data.accessToken;
        localStorage.setItem("x-access-token", token);
        createCookie("accessToken", token, 30);
        navigate(RouteConstants.HOMEPAGE),
          {
            state: localStorage.getItem("permissions"),
          };
      }
    } catch (error) {
      setStatusCode(error?.response?.data?.status);
      if (
        error?.response?.data?.status === 400 ||
        error?.response?.data?.status === 401
      ) {
        setAlertMessage(error?.response?.data?.message);
        setShowAlert(true);
      } else {
        setAlertMessage("Somthing went wrong");
        setShowAlert(false);
      }
    }
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  useEffect(() => {
    const isRemeber = localStorage.getItem("remember");
    if (isRemeber === "true") {
      const accessToken = localStorage.getItem("x-access-token");
      const decodedData = jwt_decode(accessToken);
      if (Date.now() >= decodedData.exp * 1000) {
        submitAccessToken();
      } else {
        navigate(RouteConstants.HOMEPAGE),
          {
            state: localStorage.getItem("permissions"),
          };
      }
    }
  }, []);

  const providerValue = {
    submitLogin,
    emailId,
    password,
    setEmailID,
    setPassword,
    passwordType,
    setPasswordType,
    invalidEmail,
    setInvalidEmail,
    invalidPassword,
    setInvalidPassword,
    remberMeEnable,
    setRemberMeEnable,
    showAlert,
    statusCode,
    setShowAlert,
    alertMessage,
    handleAlertSubmit,
    logout,
  };
  return (
    <LoginEmailPasswordContext.Provider value={providerValue}>
      {children}
    </LoginEmailPasswordContext.Provider>
  );
};
